import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import axios from 'axios';
import { toast } from 'react-toastify';
import {
    alertListApi,
    createAlertListApi,
    FilterIncubator,
    FilterReAdvisor,
    FilterReInvestor,
    FilterRecompany,
    filterAcquirers,
    filterInvestor,
    filterLimitedPartners,
    filterPeCompanies,
    filterRefineAdvisors,
    filterTargetCompany,
    updateAlertListApi,
    filterCfsCompanies,
} from '../../Config/config';
import Constants from '../../Constants';
import { UserContext } from '../../Contexts/UserContext';
import PrimaryButton from './PrimaryButton';

const MODULE_GROUPS = [
    {
        label: 'PE',
        options: [
            {
                value: 'pe_company',
                label: 'Company',
                typeId: Constants.moduleIds.companiesId,
                primaryMasterId: Constants.primaryMasterIds.peId,
                endpoint: filterPeCompanies,
                buildPayload: (searchKey) => ({ search_key: searchKey, category: 'investments' }),
            },
            {
                value: 'pe_investors',
                label: 'Investors',
                typeId: Constants.moduleIds.investorsId,
                primaryMasterId: Constants.primaryMasterIds.peId,
                endpoint: filterInvestor,
                buildPayload: (searchKey) => ({ search_key: searchKey, category: 'investments' }),
            },
            {
                value: 'pe_limited_partners',
                label: 'Limited Partners',
                typeId: Constants.moduleIds.limitedPartnerId,
                endpoint: filterLimitedPartners,
                buildPayload: (searchKey) => ({
                    search_key: searchKey,
                    check_starts_with: true,
                    category: 'limited_partners',
                    advisor_type: 'L',
                    module: 'pe',
                    type: 1,
                }),
            },
            {
                value: 'angel',
                label: 'Angel Investor',
                typeId: Constants.moduleIds.investorsId,
                primaryMasterId: Constants.primaryMasterIds.peId,
                endpoint: FilterIncubator,
                buildPayload: (searchKey) => ({ search_key: searchKey, category: 'incubation' }),
            },
            {
                value: 'pe_incubators',
                label: 'Incubators',
                typeId: Constants.moduleIds.incubators_id,
                endpoint: FilterIncubator,
                buildPayload: (searchKey) => ({ search_key: searchKey, category: 'incubation' }),
            },
            {
                value: 'pe_legal_advisors',
                label: 'Legal Advisors',
                typeId: Constants.moduleIds.l_advisor_id,
                primaryMasterId: Constants.primaryMasterIds.peId,
                endpoint: filterRefineAdvisors,
                buildPayload: (searchKey) => ({
                    search_key: searchKey,
                    check_starts_with: true,
                    category: 'investments',
                    advisor_type: 'L',
                    module: 'pe',
                    type: 1,
                }),
            },
            {
                value: 'pe_transaction_advisors',
                label: 'Transaction Advisors',
                typeId: Constants.moduleIds.t_advisor_id,
                primaryMasterId: Constants.primaryMasterIds.peId,
                endpoint: filterRefineAdvisors,
                buildPayload: (searchKey) => ({
                    search_key: searchKey,
                    check_starts_with: true,
                    category: 'investments',
                    advisor_type: 'T',
                    module: 'pe',
                    type: 1,
                }),
            },
        ],
    },
    {
        label: 'RE',
        options: [
            {
                value: 're_company',
                label: 'Company',
                typeId: Constants.moduleIds.companiesId,
                primaryMasterId: Constants.primaryMasterIds.reId,
                endpoint: FilterRecompany,
                buildPayload: (searchKey) => ({ search_key: searchKey, category: 're-investments' }),
            },
            {
                value: 're_investors',
                label: 'Investors',
                typeId: Constants.moduleIds.investorsId,
                primaryMasterId: Constants.primaryMasterIds.reId,
                endpoint: FilterReInvestor,
                buildPayload: (searchKey) => ({ search_key: searchKey, category: 're-investments' }),
            },
            {
                value: 're_legal_advisors',
                label: 'Legal Advisors',
                typeId: Constants.moduleIds.l_advisor_id,
                primaryMasterId: Constants.primaryMasterIds.reId,
                endpoint: FilterReAdvisor,
                buildPayload: (searchKey) => ({
                    search_key: searchKey,
                    check_starts_with: true,
                    category: 're-investments',
                    advisor_type: 'L',
                    type: 'L',
                }),
            },
            {
                value: 're_transaction_advisors',
                label: 'Transaction Advisors',
                typeId: Constants.moduleIds.t_advisor_id,
                primaryMasterId: Constants.primaryMasterIds.reId,
                endpoint: FilterReAdvisor,
                buildPayload: (searchKey) => ({
                    search_key: searchKey,
                    check_starts_with: true,
                    category: 're-investments',
                    advisor_type: 'T',
                    type: 'T',
                }),
            },
        ],
    },
    {
        label: 'MA',
        options: [
            {
                value: 'ma_company',
                label: 'Company',
                typeId: Constants.moduleIds.companiesId,
                primaryMasterId: Constants.primaryMasterIds.mANDaId,
                endpoint: filterTargetCompany,
                buildPayload: (searchKey) => ({ search_key: searchKey, category: 'ma', type: 4 }),
            },
            {
                value: 'ma_acquirers',
                label: 'Acquirers',
                typeId: Constants.moduleIds.acquirer_id,
                primaryMasterId: Constants.primaryMasterIds.mANDaId,
                endpoint: filterAcquirers,
                buildPayload: (searchKey) => ({ search_key: searchKey }),
            },
            {
                value: 'ma_legal_advisors',
                label: 'Legal Advisors',
                typeId: Constants.moduleIds.l_advisor_id,
                primaryMasterId: Constants.primaryMasterIds.mANDaId,
                endpoint: filterRefineAdvisors,
                buildPayload: (searchKey) => ({
                    search_key: searchKey,
                    check_starts_with: true,
                    category: 'ma',
                    advisor_type: 'L',
                    module: 'ma',
                }),
            },
            {
                value: 'ma_transaction_advisors',
                label: 'Transaction Advisors',
                typeId: Constants.moduleIds.t_advisor_id,
                primaryMasterId: Constants.primaryMasterIds.mANDaId,
                endpoint: filterRefineAdvisors,
                buildPayload: (searchKey) => ({
                    search_key: searchKey,
                    check_starts_with: true,
                    category: 'ma',
                    advisor_type: 'T',
                    module: 'ma',
                }),
            },
        ],
    },
    {
        label: "CFS",
        options: [
            {
                value: 'cfs_company',
                label: 'Company',
                typeId: Constants.moduleIds.companiesId,
                primaryMasterId: Constants.primaryMasterIds.cfsId,
                endpoint: filterCfsCompanies,
                buildPayload: (searchKey) => ({ search_key: searchKey, category: 'investments' }),
            },
        ]
    }
];

const MODULE_OPTIONS = MODULE_GROUPS.flatMap((group) => group.options);

const resetEntityState = (setters) => {
    setters.setEntitySearch('');
    setters.setEntityOptions([]);
    setters.setSelectedEntity(null);
    setters.setIsEntityDropdownOpen(false);
};

const resetAlertState = (setters) => {
    setters.setAlertList([]);
    setters.setSelectedAlertIds([]);
    setters.setAlertMethod('create');
    setters.setIsAlertDropdownOpen(false);
};

const NewAlertPopup = ({ show, setShow, onSaved }) => {
    const [selectedModuleKey, setSelectedModuleKey] = useState('');
    const [entitySearch, setEntitySearch] = useState('');
    const [entityOptions, setEntityOptions] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [alertList, setAlertList] = useState([]);
    const [selectedAlertIds, setSelectedAlertIds] = useState([]);
    const [alertMethod, setAlertMethod] = useState('create');
    const [isEntityDropdownOpen, setIsEntityDropdownOpen] = useState(false);
    const [isAlertDropdownOpen, setIsAlertDropdownOpen] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [isAlertLoading, setIsAlertLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const entityDropdownRef = useRef(null);
    const alertDropdownRef = useRef(null);
    const skipNextEntitySearchRef = useRef(false);
    const { getToken, getUser } = useContext(UserContext);

    const selectedModule = useMemo(
        () => MODULE_OPTIONS.find((option) => option.value === selectedModuleKey),
        [selectedModuleKey]
    );
    const userId = getUser()?.id;

    useEffect(() => {
        if (!show) {
            setSelectedModuleKey('');
            resetEntityState({ setEntitySearch, setEntityOptions, setSelectedEntity, setIsEntityDropdownOpen });
            resetAlertState({ setAlertList, setSelectedAlertIds, setAlertMethod, setIsAlertDropdownOpen });
        }
    }, [show]);

    useEffect(() => {
        if (!show) {
            return undefined;
        }

        const handleOutsideClick = (event) => {
            if (entityDropdownRef.current && !entityDropdownRef.current.contains(event.target)) {
                setIsEntityDropdownOpen(false);
            }

            if (alertDropdownRef.current && !alertDropdownRef.current.contains(event.target)) {
                setIsAlertDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [show]);

    useEffect(() => {
        if (!selectedModule || entitySearch.trim().length < 2) {
            setEntityOptions([]);
            setIsSearching(false);
            return undefined;
        }

        if (skipNextEntitySearchRef.current) {
            skipNextEntitySearchRef.current = false;
            return undefined;
        }

        const timerId = setTimeout(async () => {
            setIsSearching(true);
            try {
                const response = await axios.post(selectedModule.endpoint, selectedModule.buildPayload(entitySearch.trim()), {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                setEntityOptions(response?.data?.results ?? []);
                setIsEntityDropdownOpen(true);
            } catch (error) {
                console.log('Entity search failed', error);
                setEntityOptions([]);
            } finally {
                setIsSearching(false);
            }
        }, 300);

        return () => clearTimeout(timerId);
    }, [entitySearch, selectedModule]);

    useEffect(() => {
        if (!selectedModule || !selectedEntity || !userId) {
            return undefined;
        }

        const loadAlertList = async () => {
            setIsAlertLoading(true);
            try {
                const response = await axios.post(
                    alertListApi,
                    {
                        user_id: userId,
                        type_id: selectedModule.typeId,
                        entity_id: selectedEntity.id,
                        primary_type_master_id: selectedModule.primaryMasterId
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: getToken(),
                        },
                    }
                );

                if (response?.data?.success === true) {
                    const alerts = response?.data?.alerts ?? [];
                    setAlertList(alerts);
                    setSelectedAlertIds(alerts.filter((alert) => alert.selected).map((alert) => alert.id));
                    setAlertMethod(response?.data?.method === 'update' ? 'update' : 'create');
                } else {
                    setAlertList([]);
                    setSelectedAlertIds([]);
                    setAlertMethod('create');
                }
            } catch (error) {
                console.log('Alert list failed', error);
                setAlertList([]);
                setSelectedAlertIds([]);
                setAlertMethod('create');
            } finally {
                setIsAlertLoading(false);
            }
        };

        loadAlertList();
        return undefined;
    }, [getToken, selectedEntity, selectedModule, userId]);

    if (!show) {
        return null;
    }

    const handleClose = () => {
        setShow(false);
    };

    const handleModuleChange = (event) => {
        setSelectedModuleKey(event.target.value);
        resetEntityState({ setEntitySearch, setEntityOptions, setSelectedEntity, setIsEntityDropdownOpen });
        resetAlertState({ setAlertList, setSelectedAlertIds, setAlertMethod, setIsAlertDropdownOpen });
    };

    const handleEntityChange = (event) => {
        const nextValue = event.target.value;

        if (selectedEntity && selectedEntity.name !== nextValue) {
            setSelectedEntity(null);
            resetAlertState({ setAlertList, setSelectedAlertIds, setAlertMethod, setIsAlertDropdownOpen });
        }

        setEntitySearch(nextValue);
    };

    const handleEntitySelect = (entity) => {
        setSelectedEntity(entity);
        skipNextEntitySearchRef.current = true;
        setEntitySearch(entity.name ?? '');
        setIsEntityDropdownOpen(false);
        resetAlertState({ setAlertList, setSelectedAlertIds, setAlertMethod, setIsAlertDropdownOpen });
    };

    const toggleAlertSelection = (alertId) => {
        setSelectedAlertIds((previous) => (
            previous.includes(alertId)
                ? previous.filter((selectedId) => selectedId !== alertId)
                : [...previous, alertId]
        ));
    };

    const handleSave = async () => {
        if (!selectedModule) {
            toast.warning('Please select an alert module');
            return;
        }

        if (!selectedEntity) {
            toast.warning('Please select an entity');
            return;
        }

        if (selectedAlertIds.length === 0) {
            toast.warning('Please select alerts');
            return;
        }

        setIsSaving(true);
        try {
            const response = await axios.post(
                alertMethod === 'update' ? updateAlertListApi : createAlertListApi,
                {
                    user_id: userId,
                    alert_module_id: selectedAlertIds,
                    entity_id: selectedEntity.id,
                    type_id: selectedModule.typeId,
                    primary_type_master_id: selectedModule.primaryMasterId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: getToken(),
                    },
                }
            );

            if (response?.data?.success === true) {
                toast.success(response?.data?.message);
                onSaved?.();
                handleClose();
            } else {
                toast.warning(response?.data?.message ?? 'Unable to save alert');
            }
        } catch (error) {
            console.log('Alert save failed', error);
            toast.warning('Unable to save alert');
        } finally {
            setIsSaving(false);
        }
    };

    const selectedAlertsLabel = selectedAlertIds.length > 0
        ? `${selectedAlertIds.length} alert type${selectedAlertIds.length > 1 ? 's' : ''} selected`
        : 'Select alert types';

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-700/60 px-4">
            <div className="w-full max-w-5xl rounded-xl bg-white p-6 shadow-xl">
                <div className="flex items-start justify-between gap-4 border-b border-gray-100 pb-4">
                    <div>
                        <h2 className="text-xl font-sans_semi_bold text-[#333333]">New Alert</h2>
                        <p className="mt-1 text-sm text-gray-500">Select a module, search for an entity, then choose the alert types to subscribe.</p>
                    </div>
                    {/* <button
                        type="button"
                        className="rounded-md px-3 py-1 text-sm text-gray-500 hover:bg-gray-100"
                        onClick={handleClose}
                    >
                        Close
                    </button> */}
                </div>

                <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
                    <div className="space-y-2">
                        <label className="block text-sm font-sans_medium_body text-[#333333]">Alert Module</label>
                        <select
                            value={selectedModuleKey}
                            onChange={handleModuleChange}
                            className="h-11 w-full rounded-md border border-gray-300 px-3 text-sm focus:border-[#BC8B20] focus:outline-none"
                        >
                            <option value="">Select module</option>
                            {MODULE_GROUPS.map((group) => (
                                <optgroup key={group.label} label={group.label}>
                                    {group.options.map((moduleOption) => (
                                        <option key={moduleOption.value} value={moduleOption.value}>
                                            {moduleOption.label}
                                        </option>
                                    ))}
                                </optgroup>
                            ))}
                        </select>
                    </div>

                    <div className="space-y-2" ref={entityDropdownRef}>
                        <label className="block text-sm font-sans_medium_body text-[#333333]">Entity</label>
                        <div className="relative">
                            <input
                                type="text"
                                value={entitySearch}
                                disabled={!selectedModule}
                                onChange={handleEntityChange}
                                onFocus={() => {
                                    if (selectedModule) {
                                        setIsEntityDropdownOpen(true);
                                    }
                                }}
                                placeholder={selectedModule ? 'Type at least 2 characters' : 'Select module first'}
                                className="h-11 w-full rounded-md border border-gray-300 px-3 text-sm focus:border-[#BC8B20] focus:outline-none disabled:bg-gray-100"
                            />
                            {isEntityDropdownOpen && selectedModule ? (
                                <div className="absolute left-0 right-0 top-full mt-2 max-h-64 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
                                    {isSearching ? (
                                        <div className="px-3 py-3 text-sm text-gray-500">Searching...</div>
                                    ) : entitySearch.trim().length < 2 ? (
                                        <div className="px-3 py-3 text-sm text-gray-500">Type at least 2 characters to search.</div>
                                    ) : entityOptions.length > 0 ? (
                                        entityOptions.map((entity) => (
                                            <button
                                                key={entity.id}
                                                type="button"
                                                className="block w-full border-b border-gray-100 px-3 py-3 text-left text-sm text-[#333333] hover:bg-[#FAF5E8]"
                                                onClick={() => handleEntitySelect(entity)}
                                            >
                                                {entity.name}
                                            </button>
                                        ))
                                    ) : (
                                        <div className="px-3 py-3 text-sm text-gray-500">No entities found.</div>
                                    )}
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="space-y-2" ref={alertDropdownRef}>
                        <label className="block text-sm font-sans_medium_body text-[#333333]">Alert Types</label>
                        <div className="relative">
                            <button
                                type="button"
                                disabled={!selectedEntity || isAlertLoading}
                                onClick={() => setIsAlertDropdownOpen((previous) => !previous)}
                                className="flex h-11 w-full items-center justify-between rounded-md border border-gray-300 px-3 text-sm text-left focus:border-[#BC8B20] focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-100"
                            >
                                <span className={selectedAlertIds.length > 0 ? 'text-[#333333]' : 'text-gray-500'}>
                                    {isAlertLoading ? 'Loading alert types...' : selectedEntity ? selectedAlertsLabel : 'Select entity first'}
                                </span>
                                <span className="text-xs text-gray-400">v</span>
                            </button>

                            {isAlertDropdownOpen && selectedEntity && !isAlertLoading ? (
                                <div className="absolute left-0 right-0 top-full mt-2 max-h-64 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
                                    {alertList.length > 0 ? (
                                        alertList.map((alert) => (
                                            <label key={alert.id} className="flex cursor-pointer items-center gap-3 border-b border-gray-100 px-3 py-3 text-sm text-[#333333] hover:bg-[#FAF5E8]">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedAlertIds.includes(alert.id)}
                                                    onChange={() => toggleAlertSelection(alert.id)}
                                                    className="h-4 w-4 rounded border-gray-300 text-[#BC8B20]"
                                                />
                                                <span>{alert.alert_name}</span>
                                            </label>
                                        ))
                                    ) : (
                                        <div className="px-3 py-3 text-sm text-gray-500">No alert types available.</div>
                                    )}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className="mt-8 flex justify-end gap-3">
                    <button
                        type="button"
                        className="rounded-md border border-gray-300 px-4 py-2 text-sm text-[#333333] hover:bg-gray-50"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>
                    <PrimaryButton onClick={handleSave} disable={isSaving} isLoading={isSaving} className="ml-0 w-auto px-5">
                        {alertMethod === 'update' ? 'Update Alert' : 'Save Alert'}
                    </PrimaryButton>
                </div>
            </div>
        </div>
    )
}

export default NewAlertPopup